module.exports = __webpack_public_path__ + "img/cases-brand-tommee-5.ed7a3493.jpg";